function Hero() {
    var HeroSlider = new Swiper(".hero-slider .swiper", {
        effect: "fade",
        slidesPerView: 1,
        pagination: {
            el: ".hero-slider .swiper-pagination",
            clickable: true,
        },
    });
}

Hero();
